import { useQuery } from '@tanstack/react-query';

import {
  getOrganizationCategories,
  getMainCategories,
} from '@/features/org/api/get-organization-categories';
import { OrganizationCategory } from '@/shared/types/api';
export interface UseOrganizationCategoriesResult {
  categories: OrganizationCategory[];
  mainCategoryIds: string[];
  isLoading: boolean;
  error: Error | null;
}

export const useOrganizationCategories =
  (): UseOrganizationCategoriesResult => {
    const {
      data: categories = [],
      isLoading,
      error,
    } = useQuery({
      queryKey: ['organization-categories'],
      queryFn: getOrganizationCategories,
    });

    const mainCategoryIds = getMainCategories(categories);

    return {
      categories,
      mainCategoryIds,
      isLoading,
      error: error as Error | null,
    };
  };
